/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  CommonNotificationsList200Item,
  CommonNotificationsListParams,
  CommonNotificationsMarkAllReadCreate200
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * List all notifications for the current user (most recent first). Paginated.
 * @summary List my notifications
 */
export const commonNotificationsList = (
    params?: CommonNotificationsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CommonNotificationsList200Item[]>(
      {url: `/api/v1/common/notifications/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCommonNotificationsListQueryKey = (params?: CommonNotificationsListParams,) => {
    return [`/api/v1/common/notifications/`, ...(params ? [params]: [])] as const;
    }

    
export const getCommonNotificationsListQueryOptions = <TData = Awaited<ReturnType<typeof commonNotificationsList>>, TError = unknown>(params?: CommonNotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commonNotificationsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCommonNotificationsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof commonNotificationsList>>> = ({ signal }) => commonNotificationsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 120000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof commonNotificationsList>>, TError, TData> & { queryKey: QueryKey }
}

export type CommonNotificationsListQueryResult = NonNullable<Awaited<ReturnType<typeof commonNotificationsList>>>
export type CommonNotificationsListQueryError = unknown

/**
 * @summary List my notifications
 */
export const useCommonNotificationsList = <TData = Awaited<ReturnType<typeof commonNotificationsList>>, TError = unknown>(
 params?: CommonNotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commonNotificationsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCommonNotificationsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Mark a specific notification as read for the current user.
 * @summary Mark notification as read
 */
export const commonNotificationsMarkReadCreate = (
    id: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/common/notifications/${id}/markRead/`, method: 'POST'
    },
      );
    }
  


export const getCommonNotificationsMarkReadCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commonNotificationsMarkReadCreate>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof commonNotificationsMarkReadCreate>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof commonNotificationsMarkReadCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  commonNotificationsMarkReadCreate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CommonNotificationsMarkReadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof commonNotificationsMarkReadCreate>>>
    
    export type CommonNotificationsMarkReadCreateMutationError = void

    /**
 * @summary Mark notification as read
 */
export const useCommonNotificationsMarkReadCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commonNotificationsMarkReadCreate>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof commonNotificationsMarkReadCreate>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getCommonNotificationsMarkReadCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Mark every unread notification of the current recipient as read.
 * @summary Mark all my notifications as read
 */
export const commonNotificationsMarkAllReadCreate = (
    
 ) => {
      
      
      return customInstance<CommonNotificationsMarkAllReadCreate200>(
      {url: `/api/v1/common/notifications/markAllRead/`, method: 'POST'
    },
      );
    }
  


export const getCommonNotificationsMarkAllReadCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commonNotificationsMarkAllReadCreate>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof commonNotificationsMarkAllReadCreate>>, TError,void, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof commonNotificationsMarkAllReadCreate>>, void> = () => {
          

          return  commonNotificationsMarkAllReadCreate()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CommonNotificationsMarkAllReadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof commonNotificationsMarkAllReadCreate>>>
    
    export type CommonNotificationsMarkAllReadCreateMutationError = unknown

    /**
 * @summary Mark all my notifications as read
 */
export const useCommonNotificationsMarkAllReadCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commonNotificationsMarkAllReadCreate>>, TError,void, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof commonNotificationsMarkAllReadCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getCommonNotificationsMarkAllReadCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    